import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/router/routers'
import store from '@/store'
import config from '@/libs/config'
import browser from  '@/libs/browser'
import util from  "@/libs/util"
import werouter from  "@/router/routerConfig"
import routerUtil from  "@/router/routerUtil"

Vue.use(VueRouter);

let router = null
router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});
const turnTo = (to, role, next) => {
    if (to.path === '/') {
        next({path: werouter.index.path})
    } else if (routerUtil.is_black(to.path)) {
        next({path: routerUtil.transRouter(to.path)})
    } else {
        next()
    }
}
const isToLogin = (name)=>{
    return name===werouter.login.name || name===werouter.welogin.name || name === werouter.phonelogin.name
}
router.beforeEach((to, from, next) => {
    let params = util.getParams(to.fullPath)
    if(params.hasOwnProperty('app_id')){
        if(store.state.app.app_id !== params.app_id && params.app_id!==''){//切换了应用，退出登录
            store.commit('setToken', '');
            store.commit('setHasGetInfo',false);
        }
        store.commit('setAppId',params.app_id);
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }

    const token = config.getToken()
    let name = routerUtil.destRouterName(to.path, to.name)
    if(name === werouter.black.name
        || name === werouter.error.name
        || name === werouter.bindphone.name
        || name === werouter.register.name
        || name === werouter.resetpwd.name
        || name === werouter.alipay.name
        || name === werouter.alipayrecharge.name
        || name === werouter.apppaysucceed.name
        || name === werouter.webpaysucceed.name
    ){
        turnTo(to, null, next)
    }
    else if(name === null
        || name === werouter.index.name
        || name === werouter.author.name
        || name === werouter.match.name
        || name === werouter.message.name
        || name === werouter.mine.name
    ){
        turnTo(to, null, next)
    }
    else{
        if (!token && !isToLogin(name)) {
            // 未登录且要跳转的页面不是登录页
            next({
                name: werouter.login.name // 跳转到登录页
            })
        } else if (!token && isToLogin(name)) {
            if(name === werouter.login.name){
                // 未登陆且要跳转的页面是登录页
                if(browser.browser().wechat && store.state.app.app_id>0){//微信浏览器
                    next({
                        name: werouter.welogin.name, // 跳转到微信登录页
                        params:to.params,
                        query:to.query
                    })
                }
                else{
                    next({
                        name: werouter.phonelogin.name, // 跳转到手机登录页
                        params:to.params,
                        query:to.query
                    })
                }
            }
            else{
                next()
            }
        } else if (token && isToLogin(name)) {
            // 已登录且要跳转的页面是登录页
            next({
                name: werouter.index.name // 跳转到homeName页
            })
        } else {
            const info = config.getSystemInfo()
            if(info.app_status !== 1 ){
                if(name === werouter.slogen.name){
                    next()
                }
                else{
                    next({
                        name: werouter.slogen.name // 跳转到登录页
                    })
                }
            }
            else {
                if (store.state.user.hasGetInfo) {
                    turnTo(to, store.state.user.userInfo.role, next)
                } else {
                    store.dispatch('getUserInfo').then(user => {
                        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
                        turnTo(to, user.role, next)
                    }).catch((e) => {
                        store.commit('setToken', '');
                        store.commit('setHasGetInfo', false);
                        next({
                            name: werouter.welogin.name
                        })
                    })
                }
            }

        }
    }

});
export default router
